import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import n20ActionButtonMixin from './n20ActionButtonMixin';
export default {
  name: 'CoreN20Dialog',
  mixins: [n20ActionButtonMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: [Number, String],
      default: 900
    },
    persistent: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    cloading: function cloading() {
      return this.$store.state.app.loading;
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    hasCloseListener: function hasCloseListener() {
      return this.$listeners && this.$listeners.close;
    }
  }),
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('close');
    },
    closeOnEscape: function closeOnEscape(ev) {
      if (!this.persistent && ev.key === 'Escape') {
        this.closeDialog();
      }
    },
    closeOnClickOutSide: function closeOnClickOutSide() {
      if (!this.persistent) {
        this.closeDialog();
      }
    }
  }
};